import { useMemo } from "react";
import { ITotalCard } from "../types/ITotalCard";

export const useDataMap = (): ITotalCard[] => {
  return useMemo(
    () => [
      {
        label: "Principal Balance",
        name: "principalBal",
        higlight: true,
        children: [
          {
            label: "Principal Paid",
            value: "principalPaid",
          },
          {
            label: "Added to Balance",
            value: "principalAddedToBalance",
          },
        ],
      },
      {
        label: "Unpaid Interest",
        name: "unpaidInterestAmount",
        higlight: true,
        children: [
          {
            label: "Interest Paid",
            value: "interestPaid",
          },
          {
            label: "Calculated",
            value: "interestCalculated",
          },
        ],
      },
      {
        label: "Unpaid Late Charges",
        name: "unpaidLateChargesAmount",
        higlight: true,
        children: [
          {
            label: "Late Charges Paid",
            value: "lateChargesPaid",
          },
          {
            label: "Added to Principal",
            value: "lateChargesAddedToPrincipal",
          },
          {
            label: "Calculated",
            value: "lateChargesAssessed",
          },
        ],
      },
      {
        label: "Impound Balance",
        name: "impoundBal",
        higlight: true,
        children: [
          {
            label: "Paid from Impound",
            value: "paidFromImpound",
          },
          {
            label: "Paid to Impound",
            value: "paidToImpound",
          },
        ],
      },
      {
        label: "Fees Paid",
        name: "feesPaid",
        higlight: false,
        children: [
          {
            label: "Buyer Paid",
            value: "feesBuyerPaid",
          },
          {
            label: "Seller Paid",
            value: "feesSellerPaid",
          },
        ],
      },
    ],
    []
  );
};
